<template>
  <div>
    <div>
      <span class="text-zt-primary-200 text-zt-base">{{ $t("message.searchComponent.search_text_3_2") }}</span>
    </div>
    <div class="py-2">
      <zt-check-box data-vs-check-box="active-employee" id="documents-search-onlyactiveusersfilter" class="mr-2"
        color="secondary" v-model="activeEmployee">
        <span class="-m-2 text-zt-dark-300">{{ $t("message.documentComponent.activeEmployees") }}</span>
      </zt-check-box>
    </div>
    <div>
      <button data-vs-button="add-cuils" :class="isEmptyCuil.bgColor"
        class="w-full pl-3 py-2 border flex items-center text-left border-solid rounded border-zt-dark-300 focus:outline-none"
        @click="addCuils = true" id="documents-search-iddocumentuserfilter">
        <span class="text-zt-dark-300">{{ isEmptyCuil.content }}</span>
        <p class="text-zt-lg ml-auto pr-2">
          <zt-icon name="pencil-solid" v-if="isEmptyCuil.icon" />
        </p>
      </button>
      <zt-modal :active="addCuils" max-width="620px" :show-button-close="false" class="rounded"
        @close="addCuils = false" @keypress.esc="addCuils = false">
        <template slot="modal-header">
          <div class="p-4 w-full flex justify-between">
            <p class="font-medium text-white">
              {{ $t("message.documentComponent.toFind", { dni: $t('message.label.dni') }) }}
            </p>
            <button data-vs-button="close-modal" @click="addCuils = false"
              class="focus:outline-none font-medium text-white">
              <span>x</span>
            </button>
          </div>
        </template>
        <FormCuils @close="addCuils = false" />
      </zt-modal>
    </div>
    <div class="pt-2 px-3 pb-3">
      <span class="main--hint text-zt-dark-300">{{ $t("message.documentComponent.maxSearch", {
        dni:
          $t('message.label.dni')
      }) }}</span>
    </div>
    <div v-if="sectorAndLocationOpts.length > 0" class="border border-zt-dark-300 rounded px-2 pt-1 relative">
      <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
        $t("message.searchComponent.search_text_8") }}</label>
      <div>
        <MultiSelect :value="sectorAndLocationSelected" @input="setSectorAndLocationSelected"
          :options="sectorAndLocationOpts" :searchable="true" label="name" :multiple="true" :internal-search="true"
          :clear-on-select="true" :close-on-select="false" :preserve-search="false" :show-labels="false"
          :show-no-options="false" placeholder="" track-by="id">
          <template slot="noResult"><span class="multiselect__single">{{
            $t('message.searchComponent.not_founded')
              }}</span></template>
          <template slot="maxElements"><span class="multiselect__single">{{
            $t('message.searchComponent.max_elements')
              }}</span></template>
          <template #tag="{ remove, option }">
            <CustomChip @click="remove(option)">{{ option.name }}</CustomChip>
          </template>
        </MultiSelect>
      </div>
    </div>
    <div v-if="sectorsOpts.length > 0" class="border border-zt-dark-300 rounded px-2 pt-1 relative">
      <label id="documents-search-sectoruserfilter"
        class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
          $t("message.homeComponent.sector")
        }}</label>
      <div>
        <MultiSelect :value="sectorSelected" @input="setSectorSelected" :options="sectorsOpts" :searchable="true"
          label="name" :multiple="true" :internal-search="true" :clear-on-select="true" :close-on-select="false"
          :preserve-search="false" :show-labels="false" :show-no-options="false" placeholder="" track-by="id">
          <template slot="noResult"><span class="multiselect__single">{{
            $t('message.searchComponent.not_founded')
              }}</span></template>
          <template slot="maxElements"><span class="multiselect__single">{{
            $t('message.searchComponent.max_elements')
              }}</span></template>
          <template #tag="{ remove, option }">
            <CustomChip @click="remove(option)">{{ option.name }}</CustomChip>
          </template>
        </MultiSelect>
      </div>
    </div>
    <div v-if="locationsOpts.length > 0" class="mt-4 border border-zt-dark-300 rounded px-2 pt-1 relative">
      <label id="documents-search-locationuserfilter"
        class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
          $t("message.homeComponent.location")
        }}</label>
      <div>
        <MultiSelect :value="locationSelected" @input="setLocationSelected" :options="locationsOpts" :searchable="true"
          label="name" :multiple="true" :internal-search="true" :clear-on-select="true" :close-on-select="false"
          :preserve-search="false" :show-labels="false" :show-no-options="false" placeholder="" track-by="id">
          <template slot="noResult"><span class="multiselect__single">{{
            $t('message.searchComponent.not_founded')
              }}</span></template>
          <template slot="maxElements"><span class="multiselect__single">{{
            $t('message.searchComponent.max_elements')
              }}</span></template>
          <template #tag="{ remove, option }">
            <CustomChip @click="remove(option)">{{ option.name }}</CustomChip>
          </template>
        </MultiSelect>
      </div>
    </div>
  </div>
</template>

<script>
import CustomChip from '../CustomChip'
import { remove, isEmpty, map } from 'lodash'
import Company from '@/apiClient/Company'
import MultiSelect from 'vue-multiselect'
import { addFilters } from '../../utils'
import useCuils from '../../hooks/useCuils'
import FormCuils from './FormCuils'
import addGTMClass from '@/utils/addGTMClass'

const { store: cuilStore, setCuils } = useCuils()

export default {
  name: 'SearchEmployeeSection',
  components: {
    CustomChip,
    MultiSelect,
    FormCuils
  },
  inject: ['store', 'setFilters'],
  provide: {
    cuilStore,
    setCuils
  },
  data() {
    return {
      gtmIds: [
        'documents-search-onlyactiveusersfilter',
        'documents-search-iddocumentuserfilter',
        'documents-search-sectoruserfilter',
        'documents-search-locationuserfilter'
      ],
      companyConfig: new Company(),
      sectorSelected: [],
      locationSelected: [],
      sectorAndLocationSelected: [],
      sectorsOpts: [],
      locationsOpts: [],
      inputCuil: '',
      employeeIds: [],
      cuils: [],
      activeInput: true,
      sectorAndLocationOpts: [],
      addCuils: false
    }
  },
  async created() {
    const [sectorsAndLocationsResponse, ...rest] = await Promise.allSettled([
      this.companyConfig.getSectorAndLocation(),
      this.companyConfig.getSectors(),
      this.companyConfig.getLocations()
    ])
    if (sectorsAndLocationsResponse.status === 'rejected') {
      const [sectorResponse, locationResponse] = rest

      if (sectorResponse.status === 'fulfilled') {
        this.sectorsOpts = sectorResponse.value.data.data || []
      }

      if (locationResponse.status === 'fulfilled') {
        this.locationsOpts = locationResponse.value.data.data || []
      }
      
      setCuils([])
      return
    }

    const {
      data: { data: sectorsAndLocationsData }
    } = sectorsAndLocationsResponse.value

    this.sectorAndLocationOpts = sectorsAndLocationsData
    setCuils([])
  },
  mounted() {
    addGTMClass(this.gtmIds)
  },
  computed: {
    activeEmployee: {
      get() {
        return this.store.filters.employeeStatus === 'active' ? true : false
      },
      set(value) {
        const status = value ? 'active' : ''

        this.setStoreFilter('employeeStatus', status)
      }
    },
    isEmptyCuil() {
      return isEmpty(cuilStore.cuils)
        ? {
          content: this.$t('message.label.dni'),
          icon: false,
          bgColor: 'bg-transparent'
        }
        : {
          content: `${cuilStore.cuils.length} ${this.$t(
            'message.label.dni'
          )} ${this.$t('message.homeComponent.addeds.addeds1')}`,
          icon: true,
          bgColor: 'bg-btn-cuil'
        }
    }
  },
  methods: {
    setStoreFilter(key, input) {
      const { filters } = this.store
      const newFilters = addFilters({ ...filters }, [key, input])
      this.setFilters(newFilters)
    },
    removeCuil(cuilId) {
      remove(this.cuils, cuil => cuil === cuilId)
      this.setStoreFilter('fiscalId', [...this.cuils])
    },
    hideInput() {
      this.activeInput = false
    },
    setSectorAndLocationSelected(value) {
      this.sectorAndLocationSelected = value
      this.setStoreFilter(
        'sectorAndLocation',
        map(this.sectorAndLocationSelected, 'id')
      )
    },
    setSectorSelected(value) {
      this.sectorSelected = value
      this.setStoreFilter('sector', map(this.sectorSelected, 'id'))
    },
    setLocationSelected(value) {
      this.locationSelected = value
      this.setStoreFilter('location', map(this.locationSelected, 'id'))
    }
  }
}
</script>

<style scoped>
.main--hint {
  font-size: 10px;
  line-height: 13px;
}

.bg-btn-cuil {
  background-color: #efefef;
}
</style>
